import { Checkbox, Form, TreeSelect } from 'antd';

import { TFieldProps } from 'types';

import { getAllKeys, handleClickSelectAll } from './formTreeSelectHelpers';

const { Item } = Form;

interface ICustomTreeSelect extends Omit<TFieldProps, 'value' | 'onChange' | 'type'> {
  value?: string[];
  onChange?: (value?: string[]) => void;
}

export const CustomTreeSelect = ({
  name,
  value,
  loading,
  treeData = [],
  disabled,
  className,
  showSearch = true,
  allowClear = true,
  inputStyles,
  placeholder,
  maxTagCount,
  maxTagPlaceholder,
  onChange,
}: ICustomTreeSelect) => {
  const allKeys = getAllKeys(treeData);

  return (
    <TreeSelect
      id={name.toString()}
      treeCheckable
      value={value}
      onChange={(val) => onChange?.(val)}
      loading={loading}
      treeData={treeData}
      style={inputStyles}
      disabled={disabled}
      className={className}
      showSearch={showSearch}
      allowClear={allowClear}
      placeholder={placeholder}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={maxTagPlaceholder}
      popupMatchSelectWidth={false}
      filterTreeNode={(input, option) => String(option?.title).includes(input)
        || String(option?.title).toLowerCase().includes(input)}
      dropdownRender={(node) => (
        <>
          <Checkbox
            onChange={handleClickSelectAll(allKeys, value, onChange)}
            checked={value?.length === allKeys.length}
            className='ml-1 mb-3'
            title='Select All'
          >
            Select All
          </Checkbox>

          {node}
        </>
      )}
    />
  );
};

export const FormTreeSelect = ({
  name,
  label,
  rules,
  tooltip,
  loading,
  treeData,
  disabled,
  className,
  showSearch = true,
  allowClear = true,
  inputStyles,
  placeholder,
  itemClassName,
  maxTagCount,
  maxTagPlaceholder,
  normalize,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    rules={rules}
    label={label}
    tooltip={tooltip}
    labelAlign='left'
    className={itemClassName}
    normalize={normalize}
  >
    <CustomTreeSelect
      name={name}
      loading={loading}
      treeData={treeData}
      disabled={disabled}
      className={className}
      showSearch={showSearch}
      allowClear={allowClear}
      placeholder={placeholder}
      inputStyles={inputStyles}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={maxTagPlaceholder}
    />
  </Item>
);
